import * as React from 'react'


export default class Hint extends React.Component<{
  delay: number
  text: string
  onAddTime: (duration: number) => void
}, {
  isVisible: boolean
  isPaid
}> {

  timeout?: number

  constructor(props) {
    super(props)

    this.state = {
      isVisible: false,
      isPaid: false
    }
  }

  componentDidMount() {
    this.timeout = window.setTimeout(this.show, this.props.delay)
  }

  componentWillUnmount() {
    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }
  }

  show = () => {
    this.setState({isVisible: true})
  }

  handleClick = () => {
    if (this.state.isPaid) {
      alert(this.props.text)
    } else {
      if (confirm('Get a hint and add 2 minutes to the clock?')) {
        this.props.onAddTime(2 * 1000 * 60)
        alert(this.props.text)
        this.setState({isPaid: true})
      }
    }
  }

  render() {
    if (this.state.isVisible) {
      return <div onClick={this.handleClick} style={{position: 'absolute', top: 12, fontSize: 30, cursor: 'pointer', userSelect: 'none', zIndex: 1000}}>Hint?</div>
    } else {
      return null
    }
  }

}


// WEBPACK FOOTER //
// ./src/comp/hint.tsx